<template>
    <input v-if="readOnly" type="text" class="form-control" v-model="selected" disabled >
    <div v-else class="d-flex">
        <select class="form-control" v-model="selected" :disabled="readOnly" :required="required"
            @change="onChangeSelected">
            <option v-for="line in lines" :key="line.id" :value="line" >
                {{ line.nom }} {{ line.prenom }}
            </option>
        </select>
        <button v-if="creation" type="button" class="btn border btn-light fuz" @click="openCreateModal">
            <i class="fa-solid fa-plus"></i>
        </button>
    </div>
  </template>
  
  <script>
  import { defineComponent, defineAsyncComponent } from "vue";
  const FormClient = defineAsyncComponent(() => import('@/views/operations/clients/FormClient.vue'));
  
  export default defineComponent({
    name: "SelectClient",
    props: {
        line: {
            default: null,
        },
        required: {
            type: Boolean,
            default: false,
        },
        readOnly: {
            type: Boolean,
            default: false,
        },
        creation: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            isLoading: false,
            selected: this.line,
            lines: []
        };
    },
    mounted() {
        this.getLines()
    },
    methods: {
        onChangeSelected() {
            this.$emit('set-selected', this.selected)
        },
        openCreateModal() {
            this.$dialog.open(FormClient, {
                onClose: () => {
                    this.getLines()
                },
                props: {
                    header: "Ajouter un client ",
                    style: {
                        width: '50vw'
                    },
                    modal: true
                }
            });
        },
        getLines() {
            this.isLoading = true
            this.axios.get('/api/utilisateurs?type=client').then((response) => {
                this.lines = response.data.data
                this.isLoading = false
            }).catch(() => {
                this.isLoading = false
                this.$toast.add({
                    severity: 'error',
                    summary: 'Probleme de connexion',
                    detail: 'Une erreur s\'est produite lors de la connexion au serveur !',
                    life: 5000
                });
            })
        },
    },
  });
  </script>